import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { UseScheduleDelayProvider } from 'components/widgets/ScheduleDelay/ScheduleDelay.provider';

interface Props {
    api: UseScheduleDelayProvider['api'];
    setIsPayloadReady?: (newValue: boolean) => void;
    widgetViewMode: WidgetViewMode;
}

export const useScheduleDelayLogic = ({ api, widgetViewMode, setIsPayloadReady }: Props) => {
    const isPayloadReady = () => {
        const currentPayload = api.getScheduleDelay.payload;
        if (!currentPayload) return;
        if (
            currentPayload.compareVersionId === undefined ||
            currentPayload.latestVersionId === undefined ||
            currentPayload.contractId === undefined
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });
};
